// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"Yo-z","imageAndVideoCount":"Zo-z","imageAndVideoContainer":"_o-z","viewAllReviews":"ap-z"};